export default {
  install(Vue, options) {
    Vue.prototype.timestampToTime = function (timestamp) {
      var date = new Date(timestamp * 1000);
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() + ' ';
      var h = date.getHours() + ':';
      var m = date.getMinutes() + ':';
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    };

    Vue.prototype.getImageUrl = function (url) {

      return this.GLOBAL.BASE_URL + url
    };
    Vue.prototype.formatSeconds = function (value) {
      if (value > 0) {
        var theTime = parseInt(value);// 秒
        var middle = 0;// 分
        var hour = 0;// 小时

        if (theTime > 60) {
          middle = parseInt(theTime / 60);
          theTime = parseInt(theTime % 60);
          if (middle > 60) {
            hour = parseInt(middle / 60);
            middle = parseInt(middle % 60);
          }
        }
        var result = "" + parseInt(theTime) + "秒";
        if (middle > 0) {
          result = "" + parseInt(middle) + "分" + result;
        }
        if (hour > 0) {
          result = "" + parseInt(hour) + "小时" + result;
        }
        return result;
      } else {
        return 0;
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/utils.js